/* global KitbuilderConfig */
var App;

Marionette.TemplateCache.prototype.compileTemplate = function( rawTemplate, options ) {
	options = {
		evaluate: /<#([\s\S]+?)#>/g,
		interpolate: /\{\{\{([\s\S]+?)\}\}\}/g,
		escape: /\{\{([^\}]+?)\}\}(?!\})/g
	};

	return _.template( rawTemplate, options );
};

App = Marionette.Application.extend( {
	helpers: require( 'kitbuilder-editor-utils/helpers' ),
	heartbeat: require( 'kitbuilder-editor-utils/heartbeat' ),
	imagesManager: require( 'kitbuilder-editor-utils/images-manager' ),
	presetsFactory: require( 'kitbuilder-editor-utils/presets-factory' ),
	introduction: require( 'kitbuilder-editor-utils/introduction' ),
	templates: require( 'kitbuilder-templates/manager' ),
	ajax: require( 'kitbuilder-editor-utils/ajax' ),
	conditions: require( 'kitbuilder-editor-utils/conditions' ),
	revisions:  require( 'kitbuilder-revisions/manager' ),
	hotKeys: require( 'kitbuilder-editor-utils/hot-keys' ),

	channels: {
		editor: Backbone.Radio.channel( 'KITBUILDER:editor' ),
		data: Backbone.Radio.channel( 'KITBUILDER:data' ),
		panelElements: Backbone.Radio.channel( 'KITBUILDER:panelElements' ),
		dataEditMode: Backbone.Radio.channel( 'KITBUILDER:editmode' ),
		deviceMode: Backbone.Radio.channel( 'KITBUILDER:deviceMode' ),
		templates: Backbone.Radio.channel( 'KITBUILDER:templates' )
	},

	modules: {
		element: require( 'kitbuilder-models/element' ),
		WidgetView: require( 'kitbuilder-views/widget' ),
		controls: {
			Base: require( 'kitbuilder-views/controls/base' ),
			BaseMultiple: require( 'kitbuilder-views/controls/base-multiple' ),
			Color: require( 'kitbuilder-views/controls/color' ),
			Dimensions: require( 'kitbuilder-views/controls/dimensions' ),
			Image_dimensions: require( 'kitbuilder-views/controls/image-dimensions' ),
			Media: require( 'kitbuilder-views/controls/media' ),
			Slider: require( 'kitbuilder-views/controls/slider' ),
			Wysiwyg: require( 'kitbuilder-views/controls/wysiwyg' ),
			Choose: require( 'kitbuilder-views/controls/choose' ),
			Url: require( 'kitbuilder-views/controls/url' ),
			Font: require( 'kitbuilder-views/controls/font' ),
			Section: require( 'kitbuilder-views/controls/section' ),
			Tab: require( 'kitbuilder-views/controls/tab' ),
			Repeater: require( 'kitbuilder-views/controls/repeater' ),
			Wp_widget: require( 'kitbuilder-views/controls/wp_widget' ),
			Icon: require( 'kitbuilder-views/controls/icon' ),
			Gallery: require( 'kitbuilder-views/controls/gallery' ),
			Select2: require( 'kitbuilder-views/controls/select2' ),
			Date_time: require( 'kitbuilder-views/controls/date-time' ),
			Code: require( 'kitbuilder-views/controls/code' ),
			Box_shadow: require( 'kitbuilder-views/controls/box-shadow' ),
			Structure: require( 'kitbuilder-views/controls/structure' ),
			Animation: require( 'kitbuilder-views/controls/select2' ),
			Hover_animation: require( 'kitbuilder-views/controls/select2' ),
			Order: require( 'kitbuilder-views/controls/order' ),
			Switcher: require( 'kitbuilder-views/controls/switcher' )
		},
		templateLibrary: {
			ElementsCollectionView: require( 'kitbuilder-panel/pages/elements/views/elements' )
		}
	},

	_defaultDeviceMode: 'desktop',

	addControlView: function( controlID, ControlView ) {
		this.modules.controls[ controlID[0].toUpperCase() + controlID.slice( 1 ) ] = ControlView;
	},

	getElementData: function( modelElement ) {
		var elType = modelElement.get( 'elType' );

		if ( 'widget' === elType ) {
			var widgetType = modelElement.get( 'widgetType' );

			if ( ! this.config.widgets[ widgetType ] ) {
				return false;
			}

			return this.config.widgets[ widgetType ];
		}

		if ( ! this.config.elements[ elType ] ) {
			return false;
		}

		return this.config.elements[ elType ];
	},

	getElementControls: function( modelElement ) {
		var self = this,
			elementData = self.getElementData( modelElement );

		if ( ! elementData ) {
			return false;
		}

		var elType = modelElement.get( 'elType' ),
			isInner = modelElement.get( 'isInner' ),
			controls = {};

		_.each( elementData.controls, function( controlData, controlKey ) {
			if ( isInner && controlData.hide_in_inner || ! isInner && controlData.hide_in_top ) {
				return;
			}

			controls[ controlKey ] = _.extend( {}, self.config.controls[ controlData.type ], controlData  );
		} );

		return controls;
	},

	getControlView: function( controlID ) {
		return this.modules.controls[ controlID[0].toUpperCase() + controlID.slice( 1 ) ] || this.modules.controls.Base;
	},

	getPanelView: function() {
		return this.getRegion( 'panel' ).currentView;
	},

	initComponents: function() {
		var EventManager = require( 'kitbuilder-utils/hooks' ),
			PageSettings = require( 'kitbuilder-editor-utils/page-settings' );

		this.hooks = new EventManager();

		this.pageSettings = new PageSettings();

		this.templates.init();

		this.initDialogsManager();

		this.heartbeat.init();
		this.ajax.init();
		this.revisions.init();
		this.hotKeys.init();
	},

	initDialogsManager: function() {
		this.dialogsManager = new DialogsManager.Instance();
	},

	initElements: function() {
		var ElementModel = kitbuilder.modules.element;

		this.elements = new ElementModel.Collection( this.config.data );
	},

	initPreview: function() {
		this.$previewWrapper = Backbone.$( '#kitbuilder-preview' );

		this.$previewResponsiveWrapper = Backbone.$( '#kitbuilder-preview-responsive-wrapper' );

		var previewIframeId = 'kitbuilder-preview-iframe';

		// Make sure the iFrame does not exist.
		if ( ! Backbone.$( '#' + previewIframeId ).length ) {
			var previewIFrame = document.createElement( 'iframe' );

			previewIFrame.id = previewIframeId;
			previewIFrame.src = this.config.preview_link + '&' + ( new Date().getTime() );

			this.$previewResponsiveWrapper.append( previewIFrame );
		}

		this.$preview = Backbone.$( '#' + previewIframeId );

		this.$preview.on( 'load', _.bind( this.onPreviewLoaded, this ) );

		this.initElements();
	},

	initFrontend: function() {
		kitbuilderFrontend.setScopeWindow( this.$preview[0].contentWindow );

		kitbuilderFrontend.init();

		kitbuilderFrontend.elementsHandler.initHandlers();
	},

	initClearPageDialog: function() {
		var self = this,
			dialog;

		self.getClearPageDialog = function() {
			if ( dialog ) {
				return dialog;
			}

			dialog = this.dialogsManager.createWidget( 'confirm', {
				id: 'kitbuilder-clear-page-dialog',
				headerMessage: kitbuilder.translate( 'clear_page' ),
				message: kitbuilder.translate( 'dialog_confirm_clear_page' ),
				position: {
					my: 'center center',
					at: 'center center'
				},
				strings: {
					confirm: kitbuilder.translate( 'delete' ),
					cancel: kitbuilder.translate( 'cancel' )
				},
				onConfirm: function() {
					self.getRegion( 'sections' ).currentView.collection.reset();
				}
			} );

			return dialog;
		};
	},

	onStart: function() {
		this.$window = Backbone.$( window );

		NProgress.start();
		NProgress.inc( 0.2 );

		this.config = KitbuilderConfig;

		Backbone.Radio.DEBUG = false;
		Backbone.Radio.tuneIn( 'KITBUILDER' );

		this.initComponents();

		this.channels.dataEditMode.reply( 'activeMode', 'edit' );

		this.listenTo( this.channels.dataEditMode, 'switch', this.onEditModeSwitched );

		this.setWorkSaver();

		this.initClearPageDialog();

		this.$window.trigger( 'kitbuilder:init' );

		this.initPreview();

	},

	onPreviewLoaded: function() {
		NProgress.done();

		this.initFrontend();

		this.hotKeys.bindListener( Backbone.$( kitbuilderFrontend.getScopeWindow() ) );

		this.$previewContents = this.$preview.contents();

		var Preview = require( 'kitbuilder-views/preview' ),
			PanelLayoutView = require( 'kitbuilder-layouts/panel/panel' );

		var $previewKitbuilderEl = this.$previewContents.find( '#kitbuilder' );

		if ( ! $previewKitbuilderEl.length ) {
			this.onPreviewElNotFound();
			return;
		}

		var iframeRegion = new Marionette.Region( {
			// Make sure you get the DOM object out of the jQuery object
			el: $previewKitbuilderEl[0]
		} );

		this.$previewContents.on( 'click', function( event ) {
			var $target = Backbone.$( event.target ),
				editMode = kitbuilder.channels.dataEditMode.request( 'activeMode' ),
				isClickInsideKitbuilder = !! $target.closest( '#kitbuilder' ).length,
				isTargetInsideDocument = this.contains( $target[0] );

			if ( isClickInsideKitbuilder && 'edit' === editMode || ! isTargetInsideDocument ) {
				return;
			}

			if ( $target.closest( 'a' ).length ) {
				event.preventDefault();
			}

			/*if ( ! isClickInsideKitbuilder ) {
				var panelView = kitbuilder.getPanelView();

				console.log(panelView.getCurrentPageName());

				if ( 'elements' !== panelView.getCurrentPageName() ) {
					panelView.setPage( 'elements' );
				}
			}*/
		} );

		this.addRegions( {
			sections: iframeRegion,
			panel: '#kitbuilder-panel'
		} );

		this.getRegion( 'sections' ).show( new Preview( {
			collection: this.elements
		} ) );

		this.getRegion( 'panel' ).show( new PanelLayoutView() );

		this.$previewContents
		    .children() // <html>
		    .addClass( 'kitbuilder-html' )
		    .children( 'body' )
		    .addClass( 'kitbuilder-editor-active' );

		// this.setResizablePanel();

		this.changeDeviceMode( this._defaultDeviceMode );

		Backbone.$( '#kitbuilder-loading, #kitbuilder-preview-loading' ).fadeOut( 600 );

		_.defer( function() {
			kitbuilderFrontend.getScopeWindow().jQuery.holdReady( false );
		} );

		this.onEditModeSwitched();

		this.trigger( 'preview:loaded' );
	},

	onEditModeSwitched: function() {
		var activeMode = this.channels.dataEditMode.request( 'activeMode' );

		if ( 'edit' === activeMode ) {
			this.exitPreviewMode();
		} else {
			this.enterPreviewMode( 'preview' === activeMode );
		}
	},

	onPreviewElNotFound: function() {
		var dialog = this.dialogsManager.createWidget( 'confirm', {
			id: 'kitbuilder-fatal-error-dialog',
			headerMessage: kitbuilder.translate( 'preview_el_not_found_header' ),
			message: kitbuilder.translate( 'preview_el_not_found_message' ),
			position: {
				my: 'center center',
				at: 'center center'
			},
            strings: {
				confirm: kitbuilder.translate( 'learn_more' ),
				cancel: kitbuilder.translate( 'go_back' )
            },
			onConfirm: function() {
				open( kitbuilder.config.help_the_content_url, '_blank' );
			},
			onCancel: function() {
				parent.history.go( -1 );
			},
			hideOnButtonClick: false
		} );

		dialog.show();
	},

	setFlagEditorChange: function( status ) {
		kitbuilder.channels.editor
			.reply( 'status', status )
			.trigger( 'status:change', status );
	},

	isEditorChanged: function() {
		return ( true === kitbuilder.channels.editor.request( 'status' ) );
	},

	setWorkSaver: function() {
		this.$window.on( 'beforeunload', function() {
			if ( kitbuilder.isEditorChanged() ) {
				return kitbuilder.translate( 'before_unload_alert' );
			}
		} );
	},

	setResizablePanel: function() {
		var self = this,
			side = kitbuilder.config.is_rtl ? 'right' : 'left';

		self.panel.$el.resizable( {
			handles: kitbuilder.config.is_rtl ? 'w' : 'e',
			minWidth: 200,
			maxWidth: 680,
			start: function() {
				self.$previewWrapper
					.addClass( 'ui-resizable-resizing' )
					.css( 'pointer-events', 'none' );
			},
			stop: function() {
				self.$previewWrapper
					.removeClass( 'ui-resizable-resizing' )
					.css( 'pointer-events', '' );

				kitbuilder.channels.data.trigger( 'scrollbar:update' );
			},
			resize: function( event, ui ) {
				self.$previewWrapper
					.css( side, ui.size.width );
			}
		} );
	},

	enterPreviewMode: function( hidePanel ) {
		var $elements = this.$previewContents.find( 'body' );

		if ( hidePanel ) {
			$elements = $elements.add( 'body' );
		}

		$elements
			.removeClass( 'kitbuilder-editor-active' )
			.addClass( 'kitbuilder-editor-preview' );

		if ( hidePanel ) {
			// Handle panel resize
			this.$previewWrapper.css( kitbuilder.config.is_rtl ? 'right' : 'left', '' );

			this.panel.$el.css( 'width', '' );
		}
	},

	exitPreviewMode: function() {
		this.$previewContents
			.find( 'body' )
			.add( 'body' )
			.removeClass( 'kitbuilder-editor-preview' )
			.addClass( 'kitbuilder-editor-active' );
	},

	changeEditMode: function( newMode ) {
		var dataEditMode = kitbuilder.channels.dataEditMode,
			oldEditMode = dataEditMode.request( 'activeMode' );

		dataEditMode.reply( 'activeMode', newMode );

		if ( newMode !== oldEditMode ) {
			dataEditMode.trigger( 'switch', newMode );
		}
	},

	saveEditor: function( options ) {
		options = _.extend( {
			status: 'draft',
			onSuccess: null
		}, options );

		var self = this,
			newData = kitbuilder.elements.toJSON( { removeDefault: true } );

		return this.ajax.send( 'save_builder', {
	        data: {
		        post_id: this.config.post_id,
				status: options.status,
		        data: JSON.stringify( newData )
	        },
			success: function( data ) {
				self.setFlagEditorChange( false );

				self.config.data = newData;

				self.channels.editor.trigger( 'saved', data );

				if ( _.isFunction( options.onSuccess ) ) {
					options.onSuccess.call( this, data );
				}
			}
		} );
	},

	reloadPreview: function() {
		Backbone.$( '#kitbuilder-preview-loading' ).show();

		this.$preview[0].contentWindow.location.reload( true );
	},

	clearPage: function() {
		this.getClearPageDialog().show();
	},

	changeDeviceMode: function( newDeviceMode ) {
		var oldDeviceMode = this.channels.deviceMode.request( 'currentMode' );

		if ( oldDeviceMode === newDeviceMode ) {
			return;
		}

		Backbone.$( 'body' )
			.removeClass( 'kitbuilder-device-' + oldDeviceMode )
			.addClass( 'kitbuilder-device-' + newDeviceMode );

		this.channels.deviceMode
			.reply( 'previousMode', oldDeviceMode )
			.reply( 'currentMode', newDeviceMode )
			.trigger( 'change' );
	},


	translate: function( stringKey, templateArgs, i18nStack ) {
		if ( ! i18nStack ) {
			i18nStack = this.config.i18n;
		}

		var string = i18nStack[ stringKey ];

		if ( undefined === string ) {
			string = stringKey;
		}

		if ( templateArgs ) {
			string = string.replace( /{(\d+)}/g, function( match, number ) {
				return undefined !== templateArgs[ number ] ? templateArgs[ number ] : match;
			} );
		}

		return string;
	},

} );

module.exports = ( window.kitbuilder = new App() ).start();
